import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/mnt/agent/work/a3eaf6f60f6858aa/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/mnt/agent/work/a3eaf6f60f6858aa/layouts/error.vue").then(m => m.default || m)),
  minimal: defineAsyncComponent(() => import("/mnt/agent/work/a3eaf6f60f6858aa/layouts/minimal.vue").then(m => m.default || m))
}